module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Tovna junad icon (1).7dd2eda7.svg";